(function () {
  'use strict';

  function boot(root) {
    if (!root || root.dataset.originalsPolishMounted === 'true') return;
    var Core = window.DSDOriginalsPolishCore;
    if (!Core) return;
    root.dataset.originalsPolishMounted = 'true';
    var discoveryKey = 'dsd-originals:discovery:lib-polish-01';
    var configNode = root.querySelector('[data-originals-config]');
    var config = {};
    try { config = JSON.parse(configNode && configNode.textContent || '{}'); } catch (error) {}
    var localScope = Core.localStorageScope(config);
    var readerKey = localScope ? 'dsd-originals:reader:lib-polish-01:' + localScope : null;
    var pendingKey = config.signedIn === true && localScope ? 'dsd-originals:reader-pending:lib-polish-01:' + localScope : null;
    var search = root.querySelector('[data-originals-search]');
    var sort = root.querySelector('[data-originals-sort]');
    var dialog = root.querySelector('[data-originals-filter-dialog]');
    var countBadge = root.querySelector('[data-originals-filter-count]');
    var activeChips = root.querySelector('[data-originals-active-chips]');
    var resultCount = root.querySelector('[data-originals-result-count]');
    var empty = root.querySelector('[data-originals-empty-results]');
    var results = root.querySelector('[data-originals-results]');
    var items = Array.from(root.querySelectorAll('[data-originals-catalog-item]'));
    var discovery = readSession(discoveryKey, Core.normalizeDiscovery({}));
    var availabilityRows = null;
    var availabilityDetails = null;
    var availabilitySeries = {};
    var availabilityRequest = 0;
    var availabilityPending = false;
    var availabilityFailed = false;
    var availabilityRefreshTimer = null;
    var progressRows = null;
    var readingRows = null;
    var progressRequest = 0;
    var progressPending = false;
    var progressFailed = false;
    var pending = readPending(pendingKey);
    var reader = pending ? pending.reader : readLocal(readerKey, Core.normalizeReaderPreferences({}));
    var debounce = 0;
    var syncStatus = root.querySelector('[data-originals-reader-sync-status]');
    var syncRetry = root.querySelector('[data-originals-reader-retry]');
    var syncKeep = root.querySelector('[data-originals-reader-keep]');
    var requestScope = /^[a-f0-9]{64}$/.test(String(config.requestScope || '')) ? config.requestScope : null;
    var accountSync = config.signedIn === true && !!readerKey && !!requestScope;
    var serverVersion = null;
    var serverExtras = { autoNext: true, notificationFavoriteReleases: false };
    var serverDeliveryEnabled = false;
    var readerDirty = !!pending;
    var pendingBaseVersion = pending ? pending.baseVersion : null;
    var pendingDurable = !!pending;
    var editGeneration = 0;
    var syncInFlight = false;
    var syncTimer = 0;
    var syncConflict = false;
    var accountChanged = false;
    var notificationChoice = root.querySelector('[data-originals-notification-choice]');
    var notificationStatus = root.querySelector('[data-originals-notification-status]');
    var notificationAvailability = root.querySelector('[data-originals-notification-availability]');
    var notificationSaving = false;
    var notificationState = null;

    function showNotificationChoice() {
      if (!notificationChoice || !notificationStatus) return;
      notificationChoice.checked = !accountChanged && serverExtras.notificationFavoriteReleases;
      notificationChoice.disabled = !accountSync || serverVersion === null || readerDirty || syncInFlight || syncConflict || accountChanged || notificationSaving;
      var state = accountChanged ? 'accountChanged' : !accountSync ? 'signIn' : notificationSaving ? 'saving' : serverVersion === null ? 'loading' : syncConflict ? 'conflict' : readerDirty || syncInFlight ? 'wait' : notificationState || 'ready';
      notificationStatus.textContent = notificationStatus.dataset[state === 'saved' && serverDeliveryEnabled ? 'savedActive' : state] || '';
      if (notificationAvailability) {
        notificationAvailability.hidden = accountChanged || !accountSync || serverVersion === null;
        notificationAvailability.textContent = notificationAvailability.dataset[serverDeliveryEnabled ? 'active' : 'inactive'] || '';
      }
    }

    function showSync(state) {
      showNotificationChoice();
      if (accountChanged) ['[data-originals-reader-size]',
        '[data-originals-reader-font]', '[data-originals-reader-spacing]',
        '[data-originals-reader-motion]'].forEach(function (selector) {
        var control = root.querySelector(selector);
        if (control) control.disabled = true;
      });
      if (!syncStatus) return;
      syncStatus.textContent = syncStatus.dataset[state] || '';
      if (!syncRetry) return;
      syncRetry.hidden = state !== 'unsynced' && state !== 'conflict' && state !== 'storageUnavailable';
      if (!syncRetry.hidden) syncRetry.textContent = syncRetry.dataset[state === 'conflict' ? 'load' : 'retry'];
      if (syncKeep) syncKeep.hidden = state !== 'conflict';
    }

    function accountPreferences(method, payload) {
      return fetch('/apps/dsd-firebase-custom-token/originals-polish/preferences', {
        method: method, credentials: 'same-origin',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...(payload || {}), readerScope: requestScope })
      }).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          if (!response.ok) { var error = new Error(data.error || 'preferences_unavailable'); error.status = response.status; error.code = data.error; error.current = data.current; throw error; }
          return data;
        });
      });
    }

    function validAccountPreferences(data) {
      return data && Number.isSafeInteger(data.version) && data.version >= 0 &&
        Number.isInteger(data.textSize) && data.textSize >= 18 && data.textSize <= 28 &&
        ['serif', 'plain'].includes(data.font) && ['compact', 'comfortable', 'airy'].includes(data.spacing) &&
        ['focusMode', 'reducedMotion', 'autoNext', 'notificationFavoriteReleases'].every(function (key) { return typeof data[key] === 'boolean'; });
    }

    function useAccountPreferences(data, apply) {
      if (!validAccountPreferences(data)) throw new Error('preferences_invalid_response');
      serverVersion = data.version;
      serverDeliveryEnabled = data.notificationDeliveryEnabled === true;
      serverExtras = { autoNext: data.autoNext, notificationFavoriteReleases: data.notificationFavoriteReleases };
      if (apply) {
        reader = Core.normalizeReaderPreferences({ size: data.textSize, font: data.font, spacing: data.spacing, focus: data.focusMode, reducedMotion: data.reducedMotion });
        applyReaderPreferences(true);
        readerDirty = false;
      }
      showNotificationChoice();
    }

    function readPending(key) {
      if (!key) return null;
      try {
        var value = JSON.parse(localStorage.getItem(key) || 'null');
        if (!value || !value.reader || !(value.baseVersion === null || Number.isSafeInteger(value.baseVersion) && value.baseVersion >= 0)) return null;
        return { baseVersion: value.baseVersion, reader: Core.normalizeReaderPreferences(value.reader) };
      } catch (error) { return null; }
    }

    function writePending() {
      if (!pendingKey) return false;
      try { localStorage.setItem(pendingKey, JSON.stringify({ baseVersion: pendingBaseVersion, reader: reader })); pendingDurable = true; return true; }
      catch (error) { pendingDurable = false; return false; }
    }

    function clearPending() {
      pendingBaseVersion = null;
      pendingDurable = false;
      if (!pendingKey) return;
      try { localStorage.removeItem(pendingKey); } catch (error) {}
    }

    function loadAccountPreferences(replaceLocal) {
      if (!accountSync || accountChanged || syncInFlight) return;
      showSync('loading');
      accountPreferences('POST').then(function (data) {
        if (accountChanged) return;
        useAccountPreferences(data, replaceLocal || !readerDirty);
        if (replaceLocal) clearPending();
        syncConflict = false;
        if (!readerDirty) { showSync('synced'); return; }
        if (pendingBaseVersion === null && data.version === 0) { pendingBaseVersion = 0; writePending(); }
        if (pendingBaseVersion !== data.version) { syncConflict = true; showSync('conflict'); return; }
        scheduleSync();
      }).catch(function (error) {
        if (accountChanged) return;
        if (error.code === 'account_changed_reload') { accountChanged = true; showSync('accountChanged'); }
        else showSync(readerDirty && !pendingDurable ? 'storageUnavailable' : 'unsynced');
      });
    }

    function keepLocalPreferences() {
      if (!accountSync || !syncConflict || accountChanged || syncInFlight) return;
      showSync('loading');
      accountPreferences('POST').then(function (data) {
        if (accountChanged) return;
        useAccountPreferences(data, false);
        pendingBaseVersion = data.version;
        writePending();
        syncConflict = false;
        scheduleSync();
      }).catch(function (error) {
        if (accountChanged) return;
        if (error.code === 'account_changed_reload') { accountChanged = true; showSync('accountChanged'); }
        else showSync('conflict');
      });
    }

    function scheduleSync() {
      if (!accountSync || syncConflict || accountChanged || serverVersion === null) return;
      clearTimeout(syncTimer);
      syncTimer = setTimeout(flushPreferences, 450);
    }

    function flushPreferences() {
      if (notificationSaving || syncInFlight || !readerDirty || syncConflict || accountChanged || serverVersion === null || pendingBaseVersion !== serverVersion) return;
      syncInFlight = true;
      var generation = editGeneration;
      var input = {
        expectedVersion: pendingBaseVersion, textSize: reader.size, font: reader.font, spacing: reader.spacing,
        focusMode: reader.focus, reducedMotion: reader.reducedMotion,
        autoNext: serverExtras.autoNext, notificationFavoriteReleases: serverExtras.notificationFavoriteReleases
      };
      accountPreferences('PUT', input).then(function (data) {
        if (accountChanged) return;
        useAccountPreferences(data, false);
        readerDirty = editGeneration !== generation;
        if (readerDirty) { pendingBaseVersion = data.version; writePending(); }
        else clearPending();
        showSync(readerDirty ? 'loading' : 'synced');
      }).catch(function (error) {
        if (error.code === 'account_changed_reload') accountChanged = true;
        if (error.code === 'preferences_conflict') {
          syncConflict = true;
          if (validAccountPreferences(error.current)) useAccountPreferences(error.current, false);
        }
        showSync(accountChanged ? 'accountChanged' : syncConflict ? 'conflict' : pendingDurable ? 'unsynced' : 'storageUnavailable');
      }).finally(function () {
        syncInFlight = false;
        if (readerDirty && !syncConflict && serverVersion !== null && editGeneration !== generation) scheduleSync();
      });
    }

    function readerChanged() {
      if (accountChanged) return;
      var localStored = applyReaderPreferences(true);
      if (!accountSync) { showSync(localStored ? 'local' : 'storageUnavailable'); return; }
      if (!readerDirty) pendingBaseVersion = serverVersion;
      readerDirty = true;
      editGeneration += 1;
      writePending();
      showSync(accountChanged ? 'accountChanged' : syncConflict ? 'conflict' : serverVersion === null ? pendingDurable ? 'unsynced' : 'storageUnavailable' : 'loading');
      scheduleSync();
    }

    function saveNotificationChoice(wanted) {
      if (!notificationChoice) return;
      if (notificationChoice.disabled || accountChanged) { showNotificationChoice(); return; }
      notificationSaving = true;
      notificationState = 'saving';
      showNotificationChoice();
      accountPreferences('POST').then(function (fresh) {
        if (accountChanged) return null;
        if (!validAccountPreferences(fresh)) throw new Error('preferences_invalid_response');
        useAccountPreferences(fresh, false);
        return accountPreferences('PUT', {
          expectedVersion: fresh.version, textSize: fresh.textSize, font: fresh.font, spacing: fresh.spacing,
          focusMode: fresh.focusMode, reducedMotion: fresh.reducedMotion, autoNext: fresh.autoNext,
          notificationFavoriteReleases: wanted
        });
      }).then(function (saved) {
        if (accountChanged) return;
        useAccountPreferences(saved, false);
        if (readerDirty) { pendingBaseVersion = saved.version; writePending(); }
        notificationState = 'saved';
      }).catch(function (error) {
        if (error.code === 'account_changed_reload') accountChanged = true;
        if (error.code === 'preferences_conflict') {
          if (validAccountPreferences(error.current)) useAccountPreferences(error.current, false);
          if (readerDirty) syncConflict = true;
        }
        if (readerDirty && pendingBaseVersion !== serverVersion) syncConflict = true;
        notificationState = error.code === 'preferences_conflict' ? 'conflict' : 'failed';
      }).finally(function () {
        notificationSaving = false;
        showNotificationChoice();
        if (readerDirty && !syncConflict) scheduleSync();
      });
    }

    function readSession(key, fallback) {
      try { return Core.normalizeDiscovery(JSON.parse(sessionStorage.getItem(key) || '{}')); }
      catch (error) { return fallback; }
    }

    function readLocal(key, fallback) {
      if (!key) return fallback;
      try { return Core.normalizeReaderPreferences(JSON.parse(localStorage.getItem(key) || '{}')); }
      catch (error) { return fallback; }
    }

    function availableForItem(node) {
      if (!availabilityRows || !node.dataset.seriesId) return false;
      var wanted = discovery.formats.length ? discovery.formats : ['readable', 'audio'];
      return Object.keys(availabilityRows.read).some(function (chapterId) {
        if (availabilitySeries[chapterId] !== node.dataset.seriesId) return false;
        var readable = availabilityRows.read[chapterId] === 'available';
        var audio = availabilityRows.audio[chapterId] === 'available';
        return wanted.some(function (format) {
          return format === 'readable' && readable || format === 'audio' && audio || format === 'both' && readable && audio;
        });
      });
    }

    function accessForItem(node) {
      var labels = root.querySelector('[data-originals-discovery]').dataset;
      if (availabilityPending) return { tags: [], label: labels.accessChecking };
      if (!availabilityDetails || availabilityFailed) return { tags: [], label: labels.accessUnavailable };
      var tags = new Set();
      var kinds = new Set();
      Object.keys(availabilitySeries).forEach(function (chapterId) {
        if (availabilitySeries[chapterId] !== node.dataset.seriesId) return;
        ['read', 'audio'].forEach(function (format) {
          var row = availabilityDetails[format][chapterId];
          if (!row || row.availability === 'unavailable' || !['public', 'free_account', 'dsd_plus'].includes(row.audience)) return;
          tags.add(row.audience);
          if (row.accessKind === 'promotion' && row.audience === 'public') {
            tags.add('public_promotion'); kinds.add('public_promotion');
          } else if (row.accessKind === 'promotion' && row.audience === 'free_account') {
            kinds.add('free_promotion');
          } else if (row.accessKind === 'introductory_chapter' && row.audience === 'public') {
            tags.add('free_intro'); kinds.add('free_intro');
          } else kinds.add(row.audience);
        });
      });
      var key = kinds.size === 1 ? Array.from(kinds)[0] : kinds.size ? 'varies' : 'unavailable';
      var names = { public: 'accessPublic', free_account: 'accessFreeAccount', dsd_plus: 'accessDsdPlus',
        public_promotion: 'accessPublicPromotion', free_promotion: 'accessFreePromotion',
        free_intro: 'accessFreeIntro', varies: 'accessVaries', unavailable: 'accessUnavailable' };
      return { tags: Array.from(tags), label: labels[names[key]] || labels.accessUnavailable };
    }

    function updateAccessLabels() {
      var current = new Set();
      items.forEach(function (node) {
        var access = accessForItem(node);
        node.dataset.access = access.tags.join(',');
        access.tags.forEach(function (tag) { current.add(tag); });
        if (Array.isArray(config.chapters) && config.chapters.length) {
          var formats = new Set();
          if (availabilityRows && !availabilityFailed) Object.keys(availabilitySeries).forEach(function (chapterId) {
            if (availabilitySeries[chapterId] !== node.dataset.seriesId) return;
            var readable = availabilityRows.read[chapterId] !== 'unavailable';
            var audio = availabilityRows.audio[chapterId] !== 'unavailable';
            if (readable) formats.add('readable');
            if (audio) formats.add('audio');
            if (readable && audio) formats.add('both');
          });
          node.dataset.formats = Array.from(formats).join(',');
        }
        var label = node.querySelector('[data-originals-access-label]');
        if (label) label.textContent = access.label;
      });
      dialog.querySelectorAll('[data-filter-group="access"] input').forEach(function (input) {
        var label = input.closest('label');
        if (label) label.hidden = !current.has(input.value) && !input.checked;
      });
    }

    function accessFormatMatches(node) {
      if (!discovery.access.length || !discovery.formats.length) return true;
      if (!availabilityDetails) return false;
      return Object.keys(availabilitySeries).some(function (chapterId) {
        if (availabilitySeries[chapterId] !== node.dataset.seriesId) return false;
        return discovery.formats.some(function (format) {
          var rows = format === 'readable' ? [availabilityDetails.read[chapterId]]
            : format === 'audio' ? [availabilityDetails.audio[chapterId]]
              : [availabilityDetails.read[chapterId], availabilityDetails.audio[chapterId]];
          if (rows.some(function (row) { return !row || row.availability === 'unavailable'; })) return false;
          var audience = ['public', 'free_account', 'dsd_plus'].reduce(function (current, candidate) {
            return rows.some(function (row) { return row.audience === candidate; }) ? candidate : current;
          }, 'public');
          var tags = [audience];
          if (audience === 'public' && rows.every(function (row) { return row.accessKind === 'promotion'; })) tags.push('public_promotion');
          if (audience === 'public' && rows.every(function (row) { return row.accessKind === 'introductory_chapter'; })) tags.push('free_intro');
          return discovery.access.some(function (access) { return tags.includes(access); });
        });
      });
    }

    function progressForItem(node) {
      var chapters = Array.isArray(config.chapters) ? config.chapters.filter(function (chapter) {
        return chapter && (chapter.seriesId || config.seriesId) === node.dataset.seriesId;
      }) : [];
      if (!chapters.length) return { progress: 'not_started', recentlyPlayedAt: '' };
      var rows = chapters.map(function (chapter) {
        if (config.signedIn === true) return progressRows && progressRows[chapter.id];
        if (!chapter.audioRevision) return null;
        try {
          var key = ['dsd-originals', 'device-guest', chapter.id, chapter.audioRevision].join(':');
          var record = JSON.parse(localStorage.getItem(key) || 'null');
          if (!record || record.chapterId !== chapter.id || record.audioRevision !== chapter.audioRevision) return null;
          var position = Number(record.positionSeconds);
          return { progress: record.completed === true ? 'finished'
            : Number.isFinite(position) && position > 1 && position <= Number(chapter.durationSeconds) ? 'in_progress' : 'not_started',
          lastPlayedAt: typeof record.savedAt === 'string' && !Number.isNaN(Date.parse(record.savedAt)) ? record.savedAt : null };
        } catch (error) { return null; }
      });
      var reading = chapters.map(function (chapter) {
        if (!chapter.proseRevision) return null;
        if (config.signedIn === true) return readingRows && readingRows[chapter.id];
        try {
          var key = ['dsd-originals', 'reading-place-v1', 'device-guest', chapter.id, chapter.proseRevision].join(':');
          var record = JSON.parse(localStorage.getItem(key) || 'null');
          var match = /^paragraph-([1-9][0-9]*)$/.exec(record && record.anchor);
          if (!record || record.chapterId !== chapter.id || record.proseRevision !== chapter.proseRevision ||
              !match || Number(match[1]) > Number(chapter.proseParagraphCount)) return null;
          return { progress: 'in_progress', updatedAt: record.updatedAt };
        } catch (error) { return null; }
      });
      var touched = rows.some(function (row) { return row && ['in_progress', 'finished'].includes(row.progress); }) ||
        reading.some(function (row) { return row && row.progress === 'in_progress'; });
      var progress = !touched ? 'not_started'
        : node.dataset.releaseState === 'complete' && !reading.some(function (row) { return row && row.progress === 'in_progress'; }) &&
          rows.every(function (row) { return row && row.progress === 'finished'; })
          ? 'finished' : 'in_progress';
      var recentlyPlayedAt = rows.map(function (row) { return row && row.lastPlayedAt || ''; }).concat(
        reading.map(function (row) { return row && row.updatedAt || ''; })).sort().pop() || '';
      return { progress: progress, recentlyPlayedAt: recentlyPlayedAt };
    }

    function catalogItem(node) {
      var progress = progressForItem(node);
      return {
        title: node.dataset.title,
        summary: node.dataset.summary,
        chapterTitles: node.dataset.chapterTitles,
        tags: node.dataset.tags,
        access: node.dataset.access,
        formats: node.dataset.formats,
        progress: progress.progress,
        releaseState: node.dataset.releaseState,
        durationSeconds: Number(node.dataset.durationSeconds),
        chapterDurationsSeconds: (Array.isArray(config.chapters) ? config.chapters : []).filter(function (chapter) {
          return (chapter.seriesId || config.seriesId) === node.dataset.seriesId && chapter.published !== false &&
            (!chapter.publicationState || chapter.publicationState === 'published');
        }).map(function (chapter) { return chapter.durationSeconds; }),
        publishedAt: node.dataset.publishedAt,
        updatedAt: node.dataset.updatedAt,
        available: availableForItem(node),
        saved: node.dataset.saved === 'true',
        recentlyPlayedAt: progress.recentlyPlayedAt
      };
    }

    function selected(group) {
      return Array.from(dialog.querySelectorAll('[data-filter-group="' + group + '"] input:checked')).map(function (input) { return input.value; });
    }

    function saveDiscovery() {
      try { sessionStorage.setItem(discoveryKey, JSON.stringify(discovery)); } catch (error) {}
    }

    function syncControls() {
      search.value = discovery.query;
      sort.value = discovery.sort;
      root.querySelectorAll('[data-originals-quick]').forEach(function (button) {
        button.setAttribute('aria-pressed', button.dataset.originalsQuick === discovery.quick ? 'true' : 'false');
      });
      ['access', 'formats', 'tags', 'progress', 'releaseState', 'durations'].forEach(function (group) {
        dialog.querySelectorAll('[data-filter-group="' + group + '"] input').forEach(function (input) {
          input.checked = discovery[group].includes(input.value);
        });
      });
    }

    function renderActiveChips() {
      if (!activeChips) return;
      activeChips.replaceChildren();
      ['access', 'formats', 'tags', 'progress', 'releaseState', 'durations'].forEach(function (group) {
        discovery[group].forEach(function (value) {
          var input = Array.from(dialog.querySelectorAll('[data-filter-group="' + group + '"] input')).find(function (candidate) {
            return candidate.value === value;
          });
          var label = input && input.closest('label');
          var name = label ? label.textContent.trim() : value;
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'dsd-originals-polish__chip';
          button.dataset.filterGroup = group;
          button.dataset.filterValue = value;
          button.setAttribute('aria-label', activeChips.dataset.closeLabel + ' ' + name);
          button.textContent = name + ' ×';
          activeChips.appendChild(button);
        });
      });
      activeChips.hidden = activeChips.childElementCount === 0;
    }

    function updateDiscovery() {
      updateAccessLabels();
      var visible = [];
      items.forEach(function (node) {
        var data = catalogItem(node);
        var matches = Core.matches(data, discovery) && accessFormatMatches(node);
        node.hidden = !matches;
        if (matches) visible.push({ node: node, data: data });
      });
      visible.sort(function (left, right) {
        if (discovery.sort === 'published') return String(right.data.publishedAt).localeCompare(String(left.data.publishedAt));
        if (discovery.sort === 'updated') return String(right.data.updatedAt).localeCompare(String(left.data.updatedAt));
        if (discovery.sort === 'recently_played') return String(right.data.recentlyPlayedAt).localeCompare(String(left.data.recentlyPlayedAt));
        return String(left.data.title).localeCompare(String(right.data.title));
      }).forEach(function (entry, index) {
        if (results.children[index] !== entry.node) results.insertBefore(entry.node, results.children[index] || null);
      });
      var filterCount = Core.activeFilterCount(discovery);
      countBadge.hidden = filterCount === 0;
      countBadge.textContent = String(filterCount);
      renderActiveChips();
      var discoveryNode = root.querySelector('[data-originals-discovery]');
      resultCount.textContent = discovery.quick === 'in_progress' && progressPending ? 'Checking progress…'
        : discovery.quick === 'in_progress' && progressFailed ? 'Progress could not be checked. Tap In progress to retry.'
        : (discovery.access.length || discovery.formats.length) && availabilityPending ? 'Checking access and formats…'
        : (discovery.access.length || discovery.formats.length) && availabilityFailed ? 'Access and formats could not be checked. Tap Available to me to retry.'
        : discovery.quick === 'available' && availabilityPending ? 'Checking availability…'
        : discovery.quick === 'available' && availabilityFailed ? 'Availability could not be checked. Tap Available to me to retry.'
        : visible.length + ' ' + (visible.length === 1 ? discoveryNode.dataset.resultSingular : discoveryNode.dataset.resultPlural);
      empty.hidden = visible.length !== 0 ||
        (discovery.quick === 'available' || discovery.access.length > 0 || discovery.formats.length > 0) && (availabilityPending || availabilityFailed) ||
        discovery.quick === 'in_progress' && (progressPending || progressFailed);
      saveDiscovery();
    }

    function refreshProgressSummary() {
      var generation = ++progressRequest;
      progressRows = null;
      readingRows = null;
      progressPending = false;
      progressFailed = false;
      if (discovery.quick !== 'in_progress') return updateDiscovery();
      if (config.signedIn !== true) return updateDiscovery();
      if (accountChanged) { progressFailed = true; return updateDiscovery(); }
      if (!/^[a-f0-9]{64}$/.test(String(config.requestScope || ''))) { progressFailed = true; return updateDiscovery(); }
      var chapters = Array.isArray(config.chapters) ? config.chapters : [];
      var ids = chapters.map(function (chapter) { return chapter && chapter.id; });
      if (!ids.length || ids.length > 32 || new Set(ids).size !== ids.length || ids.some(function (id) {
        return typeof id !== 'string' || !/^[a-z0-9][a-z0-9-]{1,63}$/.test(id);
      })) { progressFailed = true; return updateDiscovery(); }
      progressPending = true;
      updateDiscovery();
      var batches = [];
      for (var offset = 0; offset < ids.length; offset += 8) batches.push(ids.slice(offset, offset + 8));
      var audioRequests = batches.map(function (batch) {
        return fetch('/apps/dsd-firebase-custom-token/originals/progress-summary', {
          method: 'POST', credentials: 'same-origin',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ chapterIds: batch, readerScope: config.requestScope })
        }).then(function (response) {
          if (!response.ok) throw new Error('progress_summary_unavailable');
          return response.json();
        }).then(function (body) {
          if (!body || body.version !== 1 || !Array.isArray(body.rows) || body.rows.length !== batch.length) throw new Error('progress_summary_invalid');
          var rows = {};
          body.rows.forEach(function (row) {
            if (!row || !batch.includes(row.chapterId) || Object.prototype.hasOwnProperty.call(rows, row.chapterId) ||
              !['not_started', 'in_progress', 'finished'].includes(row.progress) ||
              row.lastPlayedAt !== null && (typeof row.lastPlayedAt !== 'string' || Number.isNaN(Date.parse(row.lastPlayedAt)))) throw new Error('progress_summary_invalid');
            rows[row.chapterId] = row;
          });
          return rows;
        });
      });
      var readingRequests = batches.map(function (batch) {
        return fetch('/apps/dsd-firebase-custom-token/originals-polish/reading-progress', {
          method: 'POST', credentials: 'same-origin',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ chapterIds: batch, readerScope: config.requestScope })
        }).then(function (response) {
          if (!response.ok) throw new Error('reading_progress_unavailable');
          return response.json();
        }).then(function (body) {
          if (!body || body.version !== 1 || !Array.isArray(body.rows) || body.rows.length !== batch.length) throw new Error('reading_progress_invalid');
          var rows = {};
          body.rows.forEach(function (row) {
            var chapter = chapters.find(function (candidate) { return candidate.id === row.chapterId; });
            var match = /^paragraph-([1-9][0-9]*)$/.exec(row && row.anchor);
            if (!row || !batch.includes(row.chapterId) || Object.prototype.hasOwnProperty.call(rows, row.chapterId) ||
                !Number.isSafeInteger(row.version) || row.version < 0 || !['not_started', 'in_progress'].includes(row.progress) ||
                row.progress === 'in_progress' && (!chapter || row.proseRevision !== chapter.proseRevision || !match ||
                  Number(match[1]) > Number(chapter.proseParagraphCount)) ||
                row.updatedAt !== null && (typeof row.updatedAt !== 'string' || Number.isNaN(Date.parse(row.updatedAt)))) throw new Error('reading_progress_invalid');
            rows[row.chapterId] = row;
          });
          return rows;
        });
      });
      Promise.all([Promise.all(audioRequests), Promise.all(readingRequests)]).then(function (allRows) {
        if (generation !== progressRequest || discovery.quick !== 'in_progress' || accountChanged) return;
        progressRows = Object.assign({}, ...allRows[0]);
        readingRows = Object.assign({}, ...allRows[1]);
        progressPending = false;
        updateDiscovery();
      }).catch(function () {
        if (generation !== progressRequest || discovery.quick !== 'in_progress') return;
        progressPending = false;
        progressFailed = true;
        updateDiscovery();
      });
    }

    function refreshAvailability(forceHome) {
      if (availabilityRefreshTimer !== null) clearTimeout(availabilityRefreshTimer);
      availabilityRefreshTimer = null;
      var generation = ++availabilityRequest;
      availabilityRows = null;
      availabilityDetails = null;
      availabilitySeries = {};
      availabilityFailed = false;
      var home = root.querySelector('[data-originals-view="home"]');
      availabilityPending = discovery.quick === 'available' || forceHome === true || !!(home && !home.hidden);
      updateDiscovery();
      if (!availabilityPending) return;
      var chapters = Array.isArray(config.chapters) ? config.chapters : [];
      var ids = chapters.map(function (chapter) { return chapter && chapter.id; });
      if (!ids.length || ids.length > 32 || new Set(ids).size !== ids.length || chapters.some(function (chapter) {
        return !chapter || !/^[a-z0-9][a-z0-9-]{1,63}$/.test(String(chapter.id)) ||
          !/^[a-z0-9][a-z0-9-]{1,63}$/.test(String(chapter.seriesId || config.seriesId || ''));
      })) {
        availabilityPending = false;
        availabilityFailed = true;
        updateDiscovery();
        return;
      }
      chapters.forEach(function (chapter) { availabilitySeries[chapter.id] = chapter.seriesId || config.seriesId; });
      var batches = [];
      for (var offset = 0; offset < ids.length; offset += 8) batches.push(ids.slice(offset, offset + 8));
      Promise.all(batches.flatMap(function (batch) { return ['read', 'audio'].map(function (format) {
        return fetch('/apps/dsd-firebase-custom-token/originals/reference-status?chapterIds=' + encodeURIComponent(batch.join(',')) + '&format=' + format, {
          method: 'GET', credentials: 'same-origin', headers: { Accept: 'application/json' }
        }).then(function (response) {
          if (!response.ok) throw new Error('availability_unavailable');
          return response.json();
        }).then(function (body) {
          if (!body || body.version !== 2 || body.format !== format || !Array.isArray(body.rows) || body.rows.length !== batch.length) throw new Error('availability_invalid');
          var rows = {};
          var details = {};
          body.rows.forEach(function (row) {
            if (!row || !batch.includes(row.chapterId) || Object.prototype.hasOwnProperty.call(rows, row.chapterId) || !['available', 'sign_in', 'dsd_plus', 'unavailable'].includes(row.availability)) throw new Error('availability_invalid');
            rows[row.chapterId] = row.availability;
            if (['public', 'free_account', 'dsd_plus', 'unavailable'].includes(row.audience) &&
              ['base', 'promotion', 'introductory_chapter', 'unavailable'].includes(row.accessKind)) details[row.chapterId] = row;
          });
          var refreshAfterSeconds = Number.isInteger(body.refreshAfterSeconds) && body.refreshAfterSeconds >= 1 && body.refreshAfterSeconds <= 60
            ? body.refreshAfterSeconds : 60;
          return { rows: rows, details: details, refreshAfterSeconds: refreshAfterSeconds };
        });
      }); })).then(function (results) {
        var activeHome = root.querySelector('[data-originals-view="home"]');
        if (generation !== availabilityRequest || !(discovery.quick === 'available' || forceHome === true || activeHome && !activeHome.hidden)) return;
        var merged = { read: {}, audio: {} };
        var mergedDetails = { read: {}, audio: {} };
        results.forEach(function (result, index) { Object.assign(merged[index % 2 === 0 ? 'read' : 'audio'], result.rows); });
        results.forEach(function (result, index) { Object.assign(mergedDetails[index % 2 === 0 ? 'read' : 'audio'], result.details); });
        availabilityRows = merged;
        availabilityDetails = mergedDetails;
        availabilityPending = false;
        updateDiscovery();
        if (document.visibilityState === 'visible') {
          availabilityRefreshTimer = setTimeout(function () {
            availabilityRefreshTimer = null;
            var visibleHome = root.querySelector('[data-originals-view="home"]');
            if ((discovery.quick === 'available' || visibleHome && !visibleHome.hidden) && document.visibilityState === 'visible') refreshAvailability();
          }, Math.min.apply(null, results.map(function (result) { return result.refreshAfterSeconds; })) * 1000);
        }
      }).catch(function () {
        var activeHome = root.querySelector('[data-originals-view="home"]');
        if (generation !== availabilityRequest || !(discovery.quick === 'available' || forceHome === true || activeHome && !activeHome.hidden)) return;
        availabilityPending = false;
        availabilityFailed = true;
        updateDiscovery();
      });
    }

    function clearDiscovery() {
      discovery = Core.normalizeDiscovery({ sort: discovery.sort });
      syncControls();
      refreshAvailability();
    }

    var pendingReaderAnchor = null;
    var readerDialogAnchor = null;
    var readerDialogGeneration = 0;

    function openReaderDialog() {
      readerDialogAnchor = captureAnchor();
      var generation = ++readerDialogGeneration;
      if (typeof readerDialog.showModal === 'function') readerDialog.showModal();
      else readerDialog.setAttribute('open', '');
      // Native dialog focus can scroll the underlying story before a preference
      // changes. Keep the pre-dialog semantic point throughout this modal session.
      requestAnimationFrame(function () {
        if (generation === readerDialogGeneration && readerDialog.open && readerDialogAnchor) restoreReaderAnchor(readerDialogAnchor);
      });
    }

    function closeReaderDialog() {
      var anchor = readerDialogAnchor;
      readerDialogAnchor = null;
      var generation = ++readerDialogGeneration;
      requestAnimationFrame(function () {
        if (generation === readerDialogGeneration && !readerDialog.open && anchor) restoreReaderAnchor(anchor);
      });
    }
    var readerLayoutGeneration = 0;

    function readerFocusLine() {
      var height = window.innerHeight || document.documentElement.clientHeight;
      var coveredTop = 0;
      var overlays = Array.from(document.querySelectorAll('sticky-header, .section-header, header.header-wrapper, #shopify-section-header'));
      ['[data-originals-player]', '.dsd-originals-polish__reader-bar'].forEach(function (selector) {
        var node = root.querySelector(selector);
        if (node) overlays.push(node);
      });
      overlays.forEach(function (node) {
        var rect = node.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < height) coveredTop = Math.max(coveredTop, rect.bottom);
      });
      return { height: height, coveredTop: coveredTop, top: Math.min(height - 24, Math.max(height * 0.42, coveredTop + 18)) };
    }

    function captureAnchor() {
      var focus = readerFocusLine();
      var candidates = Array.from(root.querySelectorAll('[data-originals-text-mode-panel]:not([hidden]) p'));
      var selected = null;
      var nearest = Infinity;
      candidates.forEach(function (node) {
        var rect = node.getBoundingClientRect();
        if (rect.bottom <= focus.coveredTop || rect.top >= focus.height || rect.bottom <= rect.top) return;
        var distance = Math.max(rect.top - focus.top, focus.top - rect.bottom, 0);
        if (distance < nearest) { selected = node; nearest = distance; }
      });
      if (!selected) return null;
      var rect = selected.getBoundingClientRect();
      return { node: selected, fraction: Math.max(0.05, Math.min(0.95, (focus.top - rect.top) / (rect.bottom - rect.top))) };
    }

    function restoreReaderAnchor(anchor) {
      var node = anchor.node;
      if (node.isConnected === false) return;
      var panel = typeof node.closest === 'function' && node.closest('[data-originals-text-mode-panel]');
      if (panel && panel.hidden) return;
      var rect = node.getBoundingClientRect();
      if (rect.bottom <= rect.top) return;
      // Capture and restore the same semantic point at the same focus line.
      // Centering at 50% after capturing at 42% selected an earlier paragraph
      // on the next preference change. No audio seek or saved-place write here.
      var delta = rect.top + (rect.bottom - rect.top) * anchor.fraction - readerFocusLine().top;
      if (Math.abs(delta) > 0.35) window.scrollBy({ top: delta, behavior: 'auto' });
    }

    function applyReaderPreferences(preserveAnchor, persist) {
      // Rapid size/font changes share one semantic anchor until layout settles.
      var anchor = preserveAnchor ? readerDialogAnchor || pendingReaderAnchor || captureAnchor() : null;
      pendingReaderAnchor = anchor;
      var layoutGeneration = ++readerLayoutGeneration;
      var localStored = true;
      reader = Core.normalizeReaderPreferences(reader);
      root.style.setProperty('--dsd-reader-size', reader.size + 'px');
      root.dataset.readerFont = reader.font;
      root.dataset.readerSpacing = reader.spacing;
      root.dataset.readerMotion = reader.reducedMotion ? 'reduced' : 'normal';
      root.classList.toggle('dsd-originals--focus', reader.focus);
      root.querySelector('[data-originals-focus]').setAttribute('aria-pressed', reader.focus ? 'true' : 'false');
      root.querySelector('[data-originals-reader-size]').value = String(reader.size);
      root.querySelector('[data-originals-reader-size-output]').textContent = reader.size + ' px';
      root.querySelector('[data-originals-reader-font]').value = reader.font;
      root.querySelector('[data-originals-reader-spacing]').value = reader.spacing;
      root.querySelector('[data-originals-reader-motion]').checked = reader.reducedMotion;
      root.querySelector('[data-originals-reader-status]').textContent = reader.size + ' px · ' + reader.font + ' · ' + reader.spacing;
      if (preserveAnchor && persist !== false && readerKey) try { localStorage.setItem(readerKey, JSON.stringify(reader)); } catch (error) { localStored = false; }
      if (anchor) requestAnimationFrame(function () {
        if (layoutGeneration !== readerLayoutGeneration) return;
        pendingReaderAnchor = null;
        restoreReaderAnchor(anchor);
      });
      return localStored;
    }

    // Keep a pre-reflow semantic point in memory, never an audio timestamp or
    // pixel scroll offset. Resize fires after layout has already changed.
    var readerViewportWidth = window.innerWidth;
    var readerViewportAnchor = null;
    var readerViewportFrame = false;
    var readerViewportGeneration = 0;
    var readerViewportRestoring = false;

    function viewportReaderActive() {
      var panel = root.querySelector('[data-originals-text-mode-panel="read"]');
      var chapterView = root.querySelector('[data-originals-view="chapter"]');
      var follow = root.querySelector('[data-originals-follow]');
      return !accountChanged && panel && !panel.hidden && chapterView && !chapterView.hidden && !(follow && follow.checked);
    }

    function rememberReaderViewport() {
      if (readerViewportRestoring || window.innerWidth !== readerViewportWidth || !viewportReaderActive()) return;
      readerViewportAnchor = captureAnchor();
    }

    function queueReaderViewportSnapshot() {
      if (readerViewportFrame || readerViewportRestoring || !viewportReaderActive()) return;
      readerViewportFrame = true;
      requestAnimationFrame(function () {
        readerViewportFrame = false;
        rememberReaderViewport();
      });
    }

    function cancelReaderViewportRestore(event) {
      if (event && event.type === 'keydown' && !['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].includes(event.key)) return;
      readerViewportGeneration++;
      readerViewportRestoring = false;
      readerViewportAnchor = null;
      queueReaderViewportSnapshot();
    }

    function restoreReaderViewport() {
      if (window.innerWidth === readerViewportWidth) return;
      readerViewportWidth = window.innerWidth;
      var anchor = readerDialogAnchor || readerViewportAnchor;
      var generation = ++readerViewportGeneration;
      readerViewportRestoring = !!anchor && !!viewportReaderActive();
      if (!readerViewportRestoring) { readerViewportAnchor = null; return; }
      // Let the canonical player update its dynamic header offset first.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (generation !== readerViewportGeneration) return;
          if (viewportReaderActive()) restoreReaderAnchor(anchor);
          readerViewportRestoring = false;
          rememberReaderViewport();
        });
      });
    }

    if (typeof window.addEventListener === 'function') {
      window.addEventListener('scroll', queueReaderViewportSnapshot, { passive: true });
      window.addEventListener('resize', restoreReaderViewport, { passive: true });
      ['wheel', 'touchmove', 'keydown'].forEach(function (name) {
        window.addEventListener(name, cancelReaderViewportRestore, { passive: true });
      });
      root.addEventListener('dsd:originals-proseready', queueReaderViewportSnapshot);
    }

    function syncResumeCleanup() {
      var resume = root.querySelector('[data-originals-resume]');
      var noHistory = root.querySelector('[data-originals-no-history]');
      var panel = root.querySelector('[data-originals-resume-panel]');
      if (!resume || !noHistory || !panel) return;
      var validResume = !resume.hidden && /^Resume from\s+\d/.test(resume.textContent || '');
      if (noHistory.hidden !== validResume) noHistory.hidden = validResume;
      panel.dataset.hasResume = validResume ? 'true' : 'false';
    }

    root.querySelector('[data-originals-filter-open]').addEventListener('click', function () {
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    });
    root.querySelectorAll('[data-originals-clear-filters]').forEach(function (button) { button.addEventListener('click', clearDiscovery); });
    if (activeChips) activeChips.addEventListener('click', function (event) {
      var button = event.target.closest('button[data-filter-group][data-filter-value]');
      if (!button || !activeChips.contains(button)) return;
      var group = button.dataset.filterGroup;
      if (!['access', 'formats', 'tags', 'progress', 'releaseState', 'durations'].includes(group)) return;
      var nextIndex = Array.from(activeChips.children).indexOf(button);
      discovery[group] = discovery[group].filter(function (value) { return value !== button.dataset.filterValue; });
      syncControls();
      updateDiscovery();
      var nextFocus = activeChips.children[Math.min(nextIndex, activeChips.childElementCount - 1)] || root.querySelector('[data-originals-filter-open]');
      nextFocus.focus({ preventScroll: true });
    });
    root.querySelectorAll('[data-originals-quick]').forEach(function (button) {
      button.addEventListener('click', function () {
        discovery.quick = button.dataset.originalsQuick;
        syncControls();
        refreshAvailability();
        refreshProgressSummary();
      });
    });
    search.addEventListener('input', function () {
      clearTimeout(debounce);
      debounce = setTimeout(function () { discovery.query = search.value.slice(0, 120); updateDiscovery(); }, 160);
    });
    sort.addEventListener('change', function () { discovery.sort = sort.value; updateDiscovery(); });
    dialog.addEventListener('close', function () {
      discovery.access = selected('access');
      discovery.formats = selected('formats');
      discovery.tags = selected('tags');
      discovery.durations = selected('durations');
      if (discovery.quick === 'available') refreshAvailability();
      else updateDiscovery();
    });
    if (typeof window.addEventListener === 'function') {
      ['dsd:shopify-account:changed', 'dsd:shopify-logout', 'pageshow'].forEach(function (name) {
        window.addEventListener(name, function () {
          if (name !== 'pageshow') {
            accountChanged = true;
            clearTimeout(syncTimer);
            showSync('accountChanged');
          }
          var home = root.querySelector('[data-originals-view="home"]');
          if (discovery.quick === 'available' || home && !home.hidden) refreshAvailability();
          if (discovery.quick === 'in_progress') refreshProgressSummary();
        });
      });
    }
    document.addEventListener('visibilitychange', function () {
      var home = root.querySelector('[data-originals-view="home"]');
      if (document.visibilityState === 'visible' && (discovery.quick === 'available' || home && !home.hidden)) refreshAvailability();
      if (document.visibilityState === 'visible' && discovery.quick === 'in_progress') refreshProgressSummary();
      else if (document.visibilityState !== 'visible' && availabilityRefreshTimer !== null) {
        clearTimeout(availabilityRefreshTimer);
        availabilityRefreshTimer = null;
      }
    });
    root.addEventListener('dsd:originals-savedchange', updateDiscovery);
    root.addEventListener('dsd:originals-readingchange', function () {
      if (discovery.quick !== 'in_progress') return;
      if (config.signedIn === true) refreshProgressSummary();
      else updateDiscovery();
    });
    root.addEventListener('click', function (event) {
      if (!event.target.closest('[data-originals-nav="home"]')) return;
      refreshAvailability(true);
      if (discovery.quick === 'in_progress') refreshProgressSummary();
    });

    var readerDialog = root.querySelector('[data-originals-reader-dialog]');
    root.querySelector('[data-originals-reader-open]').addEventListener('click', openReaderDialog);
    readerDialog.addEventListener('close', closeReaderDialog);
    root.querySelector('[data-originals-focus]').addEventListener('click', function () {
      reader.focus = !reader.focus;
      if (accountChanged) { applyReaderPreferences(true, false); return; }
      readerChanged();
    });
    root.querySelector('[data-originals-reader-size]').addEventListener('input', function (event) { if (accountChanged) return; reader.size = Number(event.target.value); readerChanged(); });
    root.querySelector('[data-originals-reader-font]').addEventListener('change', function (event) { if (accountChanged) return; reader.font = event.target.value; readerChanged(); });
    root.querySelector('[data-originals-reader-spacing]').addEventListener('change', function (event) { if (accountChanged) return; reader.spacing = event.target.value; readerChanged(); });
    root.querySelector('[data-originals-reader-motion]').addEventListener('change', function (event) { if (accountChanged) return; reader.reducedMotion = event.target.checked; readerChanged(); });
    if (notificationChoice) notificationChoice.addEventListener('change', function (event) { saveNotificationChoice(event.target.checked); });
    if (syncRetry) syncRetry.addEventListener('click', function () { loadAccountPreferences(syncConflict); });
    if (syncKeep) syncKeep.addEventListener('click', keepLocalPreferences);
    if (accountSync && typeof window.addEventListener === 'function') window.addEventListener('online', function () {
      if (readerDirty && !syncConflict && !accountChanged) loadAccountPreferences(false);
    });

    var observer = new MutationObserver(function (records) {
      var relevant = records.some(function (record) {
        if (record.attributeName === 'data-originals-access') return true;
        var target = record.target;
        if (target.nodeType !== 1) return false;
        // Discovery owns these subtrees. Its reflected `hidden` writes in the
        // sibling filter dialog must not schedule discovery again indefinitely.
        if (target.closest('[data-originals-discovery], [data-originals-filter-dialog], [data-originals-empty-results]')) return false;
        if (target.closest('[data-originals-results]')) {
          return record.type === 'childList' && Array.from(record.addedNodes).some(function (node) {
            return node.nodeType === 1 && node.matches('[data-originals-catalog-item]');
          });
        }
        return true;
      });
      if (!relevant) return;
      syncResumeCleanup();
      updateDiscovery();
      root.querySelectorAll('[data-originals-transcript] p, [data-originals-read] p').forEach(function (paragraph, index) {
        if (!paragraph.id) paragraph.id = 'originals-paragraph-' + index;
      });
    });
    observer.observe(root, { attributes: true, childList: true, subtree: true, attributeFilter: ['hidden', 'data-originals-access'] });
    syncControls();
    updateDiscovery();
    var home = root.querySelector('[data-originals-view="home"]');
    if (discovery.quick === 'available' || home && !home.hidden) refreshAvailability();
    if (discovery.quick === 'in_progress') refreshProgressSummary();
    applyReaderPreferences(false);
    if (accountSync) loadAccountPreferences(false);
    else showSync('local');
    syncResumeCleanup();
  }

  document.querySelectorAll('[data-dsd-originals-library]').forEach(boot);
  document.addEventListener('shopify:section:load', function (event) { event.target.querySelectorAll('[data-dsd-originals-library]').forEach(boot); });
})();
